import { ActivityItem } from "./activity-item"
import { CompositeField } from "../../../shared"
import { useState } from "react"
import { ActivityModal } from "./activity-modal"
import PropTypes from "prop-types"
import { Droppable } from "react-beautiful-dnd"
import { duplicateSpecificObjectiveSubItems } from "../../../../helpers/duplicate-specific-objective-subitems"
import { useAuth } from "../../../../contexts/auth"

ActivitiesField.propTypes = {
  data: PropTypes.object,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  hiddenComments: PropTypes.array,
  review: PropTypes.bool,
  activityType: PropTypes.string,
  defaultValue: PropTypes.array,
  limitDates: PropTypes.array,
  objectiveIndex: PropTypes.number,
  removeActivity: PropTypes.func
}

export function ActivitiesField ({
  activityType,
  defaultValue,
  objectiveIndex,
  limitDates,
  onChange,
  readOnly,
  hiddenComments,
  review,
  removeActivity,
  implementationPlace,
  admin
}) {
  const [state, setState] = useState({ isModalOpen: false, edit: undefined })

  const onClickAdd = () => {
    setState({ isModalOpen: true })
  }
  const auth = useAuth() || {}
   const { user } = auth

  const onCancel = () => {
    setState({ isModalOpen: false, edit: undefined })
  }

  const onSave = (addNew, replaceItemAtIndex) => values => {
    if (typeof values.index === "undefined") {
      addNew(values)
    }
    else {
      const index = values.index
      delete values.index

      replaceItemAtIndex(index, values)
    }
    onCancel()
  }

  const onEdit = (data, index) => () => {
    const Data = {
      ...data,
      index
    }
    setState({ isModalOpen: true, edit: Data })
  }

  let roles=["IMPLEMENTER","IMPLEMENTER_TECHNICAL_MONITOR","IMPLEMENTER_ATTENDANCE_MONITOR", "IMPLEMENTER_FINANCIAL_MONITOR","IMPLEMENTER_EVALUATOR","IMPLEMENTER_COORDINATOR","IMPLEMENTER_SYSTEMATIZER"]
  let rol = roles.includes(user?.claims?.role)

  return (
    <CompositeField
      onChange={onChange}
      value={defaultValue}
      onClickAdd={onClickAdd}
      isAddDisabled={review}
      addLabel="Agregar actividad">
      {({ addNew, removeItem, replaceItemAtIndex, duplicateItem }) =>
        <Droppable
          droppableId={`${activityType}_${objectiveIndex}`}>
          {droppableProvided => (
            <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
              <ActivityModal
                rol={rol}
                activityType={activityType}
                objectiveIndex={objectiveIndex}
                onCancel={onCancel}
                onSave={onSave(addNew, replaceItemAtIndex)}
                limitDates={limitDates}
                visible={state.isModalOpen}
                readOnly={readOnly}
                edit={state.edit}
                review={review}
                hiddenComments={hiddenComments}
                implementationPlace={implementationPlace} />
              {defaultValue
                ?.map((indicator, idx) => ({ ...indicator, orderIndex: idx }))
                ?.map((item, index) =>
                  <ActivityItem
                    admin={admin}
                    rol={rol}
                    data={item}
                    review={review}
                    readOnly={readOnly}
                    index={index}
                    activityType={activityType}
                    onDelete={event => {
                      removeItem(index)(event)
                      removeActivity(item.id)
                    }}
                    onEdit={onEdit(item, index)}
                    commentID ={item.id}
                    implementationPlace={implementationPlace}
                    onDuplicate={copiedItem => {
                      duplicateItem({
                        handleWithCustomLogic: duplicateSpecificObjectiveSubItems(copiedItem)
                      })
                    }}
                    objectiveIndex={objectiveIndex}
                    key={`activity_${item.orderIndex}`} />
                )
              }
              {droppableProvided.placeholder}
            </div>
          )}
        </Droppable>
      }
    </CompositeField>
  )
}
